import { render, staticRenderFns } from "./InfoFooter.vue?vue&type=template&id=0bd1a894&scoped=true&"
import script from "./InfoFooter.vue?vue&type=script&lang=js&"
export * from "./InfoFooter.vue?vue&type=script&lang=js&"
import style0 from "./InfoFooter.vue?vue&type=style&index=0&id=0bd1a894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd1a894",
  null
  
)

export default component.exports